import {
    ChangeDetectorRef,
    Component,
    Inject,
    Input,
    ViewContainerRef,
    ViewEncapsulation
} from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';

import { ILoggingService } from '../../../services/interfaces/ILoggingService';
import { LayerService } from '../../../services/layer.service';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-additional-information-ng',
    styleUrls: [
        '../../sharedStyles/base.scss',
        '../../sharedStyles/telerik.scss',
        './data-table.component.scss'
    ],
    templateUrl: './additional-information.component.html'
})
export class DataTableAdditionalInformationComponent {
    geoSnapTableId: number = 161;
    public loading: boolean = false;
    @Input() public layerId: number;
    @Input() public childTables: any[];
    private _feature: any;
    @Input() set feature(newValue: any) {
        this._feature = newValue;
        this.refreshGridData();
    }
    get feature(): any {
        return this._feature;
    }

    public gridDataResult: GridDataResult;

    constructor(
        _vcr: ViewContainerRef,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly layerService: LayerService,
        @Inject('LoggingService') public LoggingService: ILoggingService
    ) {}

    async refreshGridData() {
        this.loading = true;
        this.changeDetectorRef.detectChanges();
        const childTableData = await this.loadChildTableData();
        this.gridDataResult = {
            data: childTableData,
            total: childTableData.length
        };
        this.loading = false;
        this.changeDetectorRef.detectChanges();
    }

    public hasChildTableRecords = (dataItem: any): boolean => {
        return dataItem.data.length > 0;
    }

    async loadChildTableData(): Promise<any> {
        const childTableFeaturePromises = [];
        for (const childTable of this.childTables) {
            let childParentKeyColumnName;
            if (childTable.tableId === this.geoSnapTableId) {
                childParentKeyColumnName = 'objectid';
            } else {
                childParentKeyColumnName = childTable.childParentKeyColumnName.toLowerCase();
            }

            const columnId = this.feature[childParentKeyColumnName];

            const childTableFeaturePromise = this.layerService.getLayerChildTable(
                this.layerId,
                childTable.tableId,
                `id name columns { name } data(filter: "${childParentKeyColumnName} = ${columnId}", fieldNames: ["*"])`
            );

            childTableFeaturePromises.push(childTableFeaturePromise);
        }
        const allChildTableDataForFeature = await Promise.all(
            childTableFeaturePromises
        );

        const childTableDictionaryArray = new Array();
        for (const record of allChildTableDataForFeature) {
            const childTable: IChildTableData = {} as IChildTableData;
            childTable.name = record[0].childTables[0].name;
            childTable.columns = record[0].childTables[0].columns;
            const dataArrayArray =
                record[0].childTables[0].data.length > 0
                    ? record[0].childTables[0].data
                    : [];
            const dataDictionaryArray = [];
            if (dataArrayArray.length > 0) {
                for (const dataArray of dataArrayArray) {
                    const dataDictionary = {};
                    for (let i = 0; i < childTable.columns.length; i++) {
                        dataDictionary[childTable.columns[i].name] =
                            dataArray[i];
                    }
                    dataDictionaryArray.push(dataDictionary);
                }
            }
            childTable.data = dataDictionaryArray;
            childTableDictionaryArray.push(childTable);
        }

        return childTableDictionaryArray;
    }
}

interface IChildTableData {
    name: string;
    columns: any[];
    data: any[];
}
